// Copyright (C) 2023, Rutio AB. All rights reserved

export const isDebug = (): boolean => {
  return window.location.host.includes('localhost') || window.location.host.includes('192.168');
};

/**
 * Check if v2 API should be used
 * Part of Phase 3 - API v2 migration
 *
 * DEFAULT: v2 API is now enabled by default
 *
 * Disable via:
 * - Environment variable: REACT_APP_USE_V2_API=false
 * - localStorage: localStorage.setItem('useV2Api', 'false')
 */
export const isV2ApiEnabled = (): boolean => {
  // Check environment variable first (for build-time config)
  if (process.env.REACT_APP_USE_V2_API === 'false') {
    return false;
  }

  // Check localStorage (for runtime toggle)
  if (typeof window !== 'undefined' && window.localStorage) {
    const setting = window.localStorage.getItem('useV2Api');
    if (setting === 'false') {
      return false;
    }
  }

  // Default to v2 API
  return true;
};

export const getApiPath = (): string => {
  const debug = isDebug();
  const v2 = isV2ApiEnabled();

  const basePath = debug
    ? window.location.hostname + ':39523'
    : window.location.hostname + '/lfndr-api';

  // Add /api/v2 suffix if v2 API is enabled
  return v2 ? basePath + '/api/v2' : basePath;
};

export const getApi = (): string => {
  const debug = isDebug();
  return (debug ? 'http://' : 'https://') + getApiPath();
};

/**
 * Get current API version
 * Returns 'v2' or 'legacy'
 */
export const getApiVersion = (): 'v2' | 'legacy' => {
  return isV2ApiEnabled() ? 'v2' : 'legacy';
};

export const getWsApi = (): string => {
  const debug = isDebug();
  return (
    (debug ? 'ws://' : 'wss://') +
    (debug ? window.location.hostname + ':39523' : window.location.hostname + ':35369')
  );
};
